export default "__VITE_ASSET__BwceGVwD__"